import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HubOfferKey, isRefiOfferType, OfferKey, OfferType } from '../../models/offers.model';
import { offersFeatureKey, OffersState } from '../reducers/offers.reducers';

const HUB_EXPRESS_OFFER_KEYS = new Set<HubOfferKey>([
  HubOfferKey.HUB_PASSIVE_AND_SECOND,
  HubOfferKey.HUB_PASSIVE_AND_SECOND_OPTIN,
]);

export const createOffersState = createFeatureSelector<OffersState>(offersFeatureKey);

// hub offers
export const selectHubOffersState = createSelector(createOffersState, (state) => state?.hubOffers);
export const selectHubOffers = createSelector(selectHubOffersState, (state) => state?.offers);
export const selectHasRefiHubOffer = createSelector(
  selectHubOffers,
  (offers) => offers && offers.some((offer) => isRefiOfferType(offer.offerType as OfferType))
);

export const selectHubOffersIsLoaded = createSelector(selectHubOffersState, (state) => state.processed);
export const selectHubOffersError = createSelector(selectHubOffersState, (state) => state?.error);
export const selectDismissHubOffer = createSelector(selectHubOffersState, (state) => state?.dismissOffer);

export const selectHasHslHubOffer = createSelector(
  selectHubOffers,
  (offers) => offers && offers.some((offer) => offer.subProductType === 'SECURED_HOME_LOAN')
);

export const selectHasExpressHubOffer = createSelector(
  selectHubOffers,
  (offers) =>
    offers?.some((offer) => HUB_EXPRESS_OFFER_KEYS.has(offer.offerKey as HubOfferKey)) ?? false
);

// offer offers
export const selectOfferOffersState = createSelector(createOffersState, (state) => state?.offerOffers);
export const selectOfferOffers = createSelector(selectOfferOffersState, (state) => state?.offers);
export const selectHasRefiOfferOffer = createSelector(
  selectOfferOffers,
  (offers) =>
    offers &&
    offers.some(
      (offer) =>
        isRefiOfferType(offer.offerType as OfferType) ||
        offer.offerKey === OfferKey.OFFERS_ITA_REFINANCE_SINGLE_LOAN ||
        offer.offerKey === OfferKey.OFFERS_ITA_REFINANCE_MULTI_LOAN
    )
);

export const selectHasHslOfferOffer = createSelector(
  selectOfferOffers,
  (offers) => offers && offers.some((offer) => offer.subProductType === 'SECURED_HOME_LOAN')
);

export const selectOfferOffersIsLoaded = createSelector(selectOfferOffersState, (state) => state.processed);
export const selectOfferOffersError = createSelector(selectOfferOffersState, (state) => state?.error);
export const selectDismissOfferOffer = createSelector(selectOfferOffersState, (state) => state?.dismissOffer);
